import { render, staticRenderFns } from "./FavoriteAds.vue?vue&type=template&id=2678221f&scoped=true&"
import script from "./FavoriteAds.vue?vue&type=script&lang=js&"
export * from "./FavoriteAds.vue?vue&type=script&lang=js&"
import style0 from "./FavoriteAds.vue?vue&type=style&index=0&id=2678221f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2678221f",
  null
  
)

export default component.exports